/**
 * Tono visual de cada acción (color del badge). Una acción "positiva"
 * es una creación / autorización / login exitoso. "Negativa" es una
 * eliminación / cancelación / login fallido. Lo neutral va en gris.
 *
 * Mantén estas listas sincronizadas con las acciones que emite el
 * backend en `Modules.Administracion.Domain.AuditoriaCambios`.
 */
export const ACCIONES_POSITIVAS = new Set([
  "Cargado",
  "Crear",
  "Reactivar",
  "AgregarSatOverride",
  "IniciarSolicitud",
  "ConfirmarProrrateo",
  "AutorizarNivel",
  "EnviarAAutorizacion",
  "AgregarLineaManual",
  "SubirDocumento",
  "LoginExitoso",
  "TokenRefresh",
]);

export const ACCIONES_NEGATIVAS = new Set([
  "Eliminado",
  "Eliminar",
  "DarDeBaja",
  "QuitarSatOverride",
  "CancelarSolicitud",
  "RechazarSolicitud",
  "DarDeBajaSolicitud",
  "EliminarLineaProrrateo",
  "EliminarDocumento",
  "LoginFallido",
  "AccesoDenegado",
]);

export function colorDeAccion(accion: string): string {
  if (ACCIONES_POSITIVAS.has(accion)) return "info";
  if (ACCIONES_NEGATIVAS.has(accion)) return "peligro";
  return "slate";
}

/**
 * Mapeo categoría → color (badge). El backend tiene 12+ categorías ·
 * usamos un mapa exhaustivo y caemos a gris para nuevas no mapeadas.
 */
export const COLOR_POR_CATEGORIA: Record<string, string> = {
  Organizacion: "exito",
  Proveedor: "carmin",
  Area: "slate",
  Usuario: "info",
  NivelAutorizacion: "ambar",
  SatOverride: "carmin",
  Solicitud: "azulProfundo",
  Prorrateo: "azulCielo",
  Cfdi: "exito",
  Documento: "advertencia",
  FlujoAutorizacion: "azulProfundo",
  Poliza: "peligro",
  Acceso: "slate",
};
